function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LayoutController = /*#__PURE__*/function () {
  function LayoutController() {
    _classCallCheck(this, LayoutController);
    this.items = [];
    this.groups = {};
    this.columns = 1;
  }
  _createClass(LayoutController, [{
    key: "addItem",
    value: function addItem(item) {
      var _this = this;
      item.addEventListener('mouseenter', function (e) {
        e.preventDefault();
        // Remove the active class from all items in the group, then add it to the item that was hovered
        _this.getGroupByItem(item).forEach(function (el) {
          var activeWidth = 100 / _this.columns * 2;
          var normalWidth = 100 / _this.columns * 1;
          el.classList.remove('hover');
          if (el === item) {
            el.style.width = "".concat(activeWidth, "%");
            // item.classList.add('active');
          } else {
            el.style.width = "".concat(normalWidth, "%");
            // el.classList.remove('active');
          }
        });

        // Add the hover class to the item that was hovered
        item.classList.add('hover');
      });
      this.items.push(item);
    }
  }, {
    key: "getGroupByItem",
    value: function getGroupByItem(item) {
      var groups = Object.keys(this.groups);
      for (var i = 0; i < groups.length; i++) {
        if (this.groups[groups[i]].indexOf(item) > -1) {
          console.log(groups[i]);
          return this.groups[groups[i]];
        }
      }
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      var _this2 = this;
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      // If the number of columns hasn't changed, return the groups object
      if (x - 1 === this.columns) return this.groups;
      this.columns = x + 1;
      // clear the groups object
      this.groups = {};

      // loop through all items
      this.items.forEach(function (item, index) {
        // We are going to move items to the groups object in groups of X
        // So if X is 3, we will move the first 3 items to the first group, the next 3 to the second group, etc.
        // To do this, we will use the index of the item and divide it by X, then round down to get the group number
        var group = Math.floor(index / x);

        // if the group doesn't exist yet, create it
        if (!_this2.groups[group]) _this2.groups[group] = [];
        item.style.width = "".concat(100 / _this2.columns, "%");
        // item.classList.remove('active');
        item.classList.remove('hover');
        item.classList.remove('right');

        // add the item to the group
        _this2.groups[group].push(item);
      });
      Object.keys(this.groups).forEach(function (key, index) {
        var firstItem = _this2.groups[key][0];
        var lastItem = _this2.groups[key][_this2.groups[key].length - 1];
        // if index is even, set the last item to active, otherwise set the first item to active
        if (index % 2 === 0) {
          // First item
          firstItem.style.width = "".concat(100 / _this2.columns * 2, "%");
          firstItem.classList.add('hover');
        } else {
          // Last item
          lastItem.style.width = "".concat(100 / _this2.columns * 2, "%");
          lastItem.classList.add('hover');
        }
        if (_this2.groups[key].indexOf(lastItem) === _this2.columns - 2) {
          lastItem.classList.add('right');
        }
      });
      return this.groups;
    }

    // update() {
    //   let index = 0;

    //   // loop through all groups
    //   Object.keys(this.groups).forEach((key) => {
    //     // if index is even, set the last item to active, otherwise set the first item to active
    //     this.groups[key].forEach((item) => {
    //       item.classList
    //     });
    //   });
    // }
  }]);
  return LayoutController;
}(); // Loop through all solutions blocks
_toConsumableArray(document.querySelectorAll('.js-solutions')).forEach(function (block) {
  var Layout = new LayoutController();
  // some timeouts
  var timeouts = {};
  // Used to keep track of the number of columns
  var columns = 1;
  var Observer = new ResizeObserver(function () {
    columns = 1;
    // if (window.innerWidth >= 768) columns = 2;
    if (window.innerWidth >= 1024) columns = 2;
    if (window.innerWidth >= 1440) columns = 3;
    Layout.getGroups(columns);
    clearTimeout(timeouts['update']);
    block.classList.remove('transitions');
    timeouts['update'] = setTimeout(function () {
      block.classList.add('transitions');
    }, 100);
  });
  Observer.observe(block);
  _toConsumableArray(block.querySelectorAll('.js-solution__item')).forEach(function (item) {
    Layout.addItem(item);
  });
  console.log(Layout.getGroups(2));
});